import { isPathLike } from './isPathLike';
import { stringIncludes } from './stringIncludes';
import { isNumber } from './isNumber';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import sumBy from 'lodash/sumBy';
export var util = {
    isNumber: isNumber,
    isPathLike: isPathLike,
    stringIncludes: stringIncludes,
    groupBy: function (items, iteratee) {
        return groupBy(items, iteratee);
    },
    orderBy: function (items, iteratee, direction) {
        return orderBy(items, iteratee, direction);
    },
    sumBy: function (items, iteratee) {
        return sumBy(items, iteratee);
    },
};
